import { Directive, ElementRef, Renderer2, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { DecimalPipe } from '@angular/common';

@Directive({
  selector: '[appDecimal]',
})
export class DecimalDirective {

  private oldValue = '';
  private isBeforeSemiColor = false;

  constructor(
    private el: ElementRef,
    private render: Renderer2,
    private control: NgControl,
    private decimalPipe: DecimalPipe,
  ) { }

  @HostListener('input', ['$event']) oninput(event: any) {
    const regex = /^[0-9\.0-9]{0,}(\,\d{1,2})*$/;
    let value = this.el.nativeElement.value;
    value = value.replace(/[^0-9\,]/gm, '');
    if (event.data) {
      if (!regex.test(value)) {
        if (this.isBeforeSemiColor) {
          value = this.oldValue;
        }
        event.stopPropagation();
      }
      this.oldValue = value;
      value = this.proccessNumber(value, event);
      this.changeInputValue(value);
      if (event.data === ',') {
        this.isBeforeSemiColor = true;
      }
    } else {
      if (value === '$ ') {
        this.oldValue = '';
        this.isBeforeSemiColor = false;
        this.changeInputValue('');
      } else {
        this.oldValue = value;
        this.isBeforeSemiColor = value.includes(',');
        this.changeInputValue(this.proccessNumber(value, event));
      }
    }
  }

  private proccessNumber(value: string, event: any): string {
    const arrayValues = value.includes(',') ? value.split(',') : [value];
    const partInt = arrayValues[0].replace(/[\.]/gm, '');
    const partDec = arrayValues[1];
    const valueTransform = this.decimalPipe.transform(parseFloat(partInt), '1.0', 'en-US');
    let newvalue = valueTransform ? `$ ${valueTransform}` : '';
    newvalue = newvalue.replace(/[\,]/gm, '.');

    if (event.data === ',' || value.includes(',')) {
      newvalue = newvalue + ',' + (partDec || '');
    }
    return newvalue;
  }

  private changeInputValue(value) {
    const abstractControl = this.control.control;
    if (abstractControl) {
      abstractControl.setValue(value);
    }
    this.render.setProperty(this.el.nativeElement, 'value', value);
  }
}
